interface accomplished {
  stackSegmentBudgetValue: [];
  stackSegmentRevenueValue: [];
  stackSegmentInvoiceValue: [];
  stackSegmentBudgetValueLegend: [];
  stackSegmentRevenueValueLegend: [];
  stackSegmentInvoiceValueLegnd: [];
  legendCarriedMask: [];
  legendChart: [];
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const seriesChart = (accomplishedSegment: any): accomplished => {
  accomplishedSegment = Object.fromEntries(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.entries(accomplishedSegment).filter(([key, val]) => {
      return typeof val === 'object';
    })
  );
  accomplishedSegment = Object.values(accomplishedSegment);

  const stackSegmentBudgetValue = accomplishedSegment.map(
    (el) => el.segmentBudgetValue
  );

  const stackSegmentBudgetValueLegend = accomplishedSegment.map(
    (el) => el.segmentBudgetValueMask
  );

  const stackSegmentRevenueValue = accomplishedSegment.map(
    (el) => el.segmentRevenueValue
  );

  const stackSegmentRevenueValueLegend = accomplishedSegment.map(
    (el) => el.segmentRevenueValueMask
  );

  const stackSegmentInvoiceValue = accomplishedSegment.map(
    (el) => el.segmentInvoiceValue
  );

  const stackSegmentInvoiceValueLegnd = accomplishedSegment.map(
    (el) => el.segmentInvoiceValueMask
  );

  const legendChart = accomplishedSegment.map(
    (el) =>
      el.segmentName[0].toUpperCase() + el.segmentName.slice(1).toLowerCase()
  );

  const legendCarriedMask = accomplishedSegment.map(
    (el) => el.segmentCarriedValueMask
  );
  return {
    stackSegmentBudgetValue,
    stackSegmentRevenueValue,
    stackSegmentInvoiceValue,
    stackSegmentBudgetValueLegend,
    stackSegmentRevenueValueLegend,
    stackSegmentInvoiceValueLegnd,
    legendCarriedMask,
    legendChart,
  } as accomplished;
};
